import { Balance } from '../../../domain/models/Balance';
import { ResumeSellPerDay } from '../../../domain/models/ResumeSellPerDay';
import { ActionType } from '../ActionsTypes';
import { ReducerAction } from '../ReducerAction';
import { BalanceState } from '../states/BalanceState';

export const balanceReducer = (state = new BalanceState({
    balance: new Balance({}),
    resumeSellPerDay: new ResumeSellPerDay({}),
    historic: []
}), action: ReducerAction) => {

    switch (action.type) {
        case ActionType.BALANCE_UPDATE:
            return new BalanceState({
                ...state,
                balance: action.payload
            })
        case ActionType.BALANCE_UPDATE_RESUME_PER_DAY:
            return new BalanceState({
                ...state,
                resumeSellPerDay: action.payload
            });

        case ActionType.BALANCE_UPDATE_HISTORIC:
            return new BalanceState({
                ...state,
                historic: action.payload
            });
        default: return state;
    }
}